import { c as _c } from "react/compiler-runtime";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import WaveDropContent from "../WaveDropContent";
import useIsTouchDevice from "@/hooks/useIsTouchDevice";
interface ParticipationDropContentProps {
  readonly drop: ExtendedDrop;
  readonly activePartIndex: number;
  readonly setActivePartIndex: (index: number) => void;
  readonly onLongPress: () => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly setLongPressTriggered: (triggered: boolean) => void;
  readonly isCompetitionDrop?: boolean | undefined;
}
export default function ParticipationDropContent(t0) {
  const $ = _c(10);
  const {
    drop,
    activePartIndex,
    setActivePartIndex,
    onLongPress,
    onDropContentClick,
    onQuoteClick,
    setLongPressTriggered,
    isCompetitionDrop: t1
  } = t0;
  const isCompetitionDrop = t1 === undefined ? false : t1;
  const hasTouch = useIsTouchDevice();
  let t2;
  if ($[0] !== activePartIndex || $[1] !== drop || $[2] !== hasTouch || $[3] !== isCompetitionDrop || $[4] !== onDropContentClick || $[5] !== onLongPress || $[6] !== onQuoteClick || $[7] !== setActivePartIndex || $[8] !== setLongPressTriggered) {
    t2 = <div><WaveDropContent drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onLongPress={onLongPress} onDropContentClick={onDropContentClick} onQuoteClick={onQuoteClick} setLongPressTriggered={setLongPressTriggered} isCompetitionDrop={isCompetitionDrop} hasTouch={hasTouch} /></div>;
    $[0] = activePartIndex;
    $[1] = drop;
    $[2] = hasTouch;
    $[3] = isCompetitionDrop;
    $[4] = onDropContentClick;
    $[5] = onLongPress;
    $[6] = onQuoteClick;
    $[7] = setActivePartIndex;
    $[8] = setLongPressTriggered;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}